const ClipType = {
  LONG_SD: 1,
  SHORT_HD: 2,
  SHORT_BEST_AVAILABLE: 3,
  properties: {
    1: { rawValue: 'aligned_clip' },
    2: { rawValue: 'hd_clip' },
    3: { rawValue: 'available_aligned_or_short' },
  },
}

if (Object.freeze) {
  Object.freeze(ClipType)
}

export { ClipType }
